const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const now = new Date();
const nextWeek = new Date(now);
nextWeek.setDate(now.getDate() + 7);

const mockVehicles = [
  {
    id: 101,
    plate: "ABC1D23",
    nickname: "Fiorino Entregas",
    clientName: "Comercial Aurora",
    companyName: "Comercial Aurora LTDA",
    contractStatus: "Ativo",
    cpfCnpj: "12.345.678/0001-10",
  },
  {
    id: 102,
    plate: "QWE4R56",
    nickname: "Sprinter Norte",
    clientName: "TransLog Norte",
    companyName: "TransLog Norte SA",
    contractStatus: "Ativo",
    cpfCnpj: "33.444.555/0001-20",
  },
  {
    id: 103,
    plate: "XYZ9K87",
    nickname: "Pickup Suporte",
    clientName: "Grupo Delta",
    companyName: "Grupo Delta Servicos",
    contractStatus: "Suspenso",
    cpfCnpj: "11.222.333/0001-99",
  },
];

const detailsByVehicleId = {
  101: {
    client: {
      name: "Comercial Aurora",
      fantasyName: "Aurora Distribuicao",
      cpfCnpj: "12.345.678/0001-10",
      phone: "(11) 3333-1010",
      address: "Rua da Industria, 245\nBairro Centro\nSao Paulo - SP",
      email: "suporte@aurora.com.br",
      personType: "Pessoa Juridica",
      customerObservation:
        "Cliente com prioridade alta para bloqueio preventivo e acompanhamento de eventos.",
      vehicleContractObservation:
        "Contrato empresarial com rastreamento em tempo real e comandos remotos habilitados.",
    },
    vehicle: {
      id: 101,
      brand: "Fiat",
      model: "Fiorino",
      plate: "ABC1D23",
      year: "2022",
      color: "Branco",
      equipment: "MX-Tracker 4G",
      serial: "SN-88910011",
      carrier: "Vivo",
      lineNumber: "(11) 98888-1122",
    },
    status: {
      hasBlocking: true,
      inMaintenance: false,
    },
    maintenance: {
      vehicleLabel: "ABC1D23 - Fiorino",
      startDate: "",
      endDate: "",
    },
    internalObservation:
      "Contato principal no financeiro.\nValidar fatura antes de enviar comando de bloqueio.",
  },
  102: {
    client: {
      name: "TransLog Norte",
      fantasyName: "TL Norte",
      cpfCnpj: "33.444.555/0001-20",
      phone: "(31) 3232-2020",
      address: "Av. dos Transportes, 900\nDistrito Industrial\nBelo Horizonte - MG",
      email: "atendimento@translognorte.com.br",
      personType: "Pessoa Juridica",
      customerObservation: "Cliente com SLA de 2 horas para retorno.",
      vehicleContractObservation:
        "Equipamento com sensor de ignicao e alertas de velocidade.",
    },
    vehicle: {
      id: 102,
      brand: "Mercedes",
      model: "Sprinter",
      plate: "QWE4R56",
      year: "2021",
      color: "Prata",
      equipment: "MX-Tracker PRO",
      serial: "SN-99887766",
      carrier: "Claro",
      lineNumber: "(31) 97777-4455",
    },
    status: {
      hasBlocking: false,
      inMaintenance: true,
    },
    maintenance: {
      vehicleLabel: "QWE4R56 - Sprinter",
      startDate: "2026-04-10",
      endDate: "2026-04-20",
    },
    internalObservation: "Monitorar retorno da manutencao e validar testes de campo.",
  },
  103: {
    client: {
      name: "Grupo Delta",
      fantasyName: "Delta Support",
      cpfCnpj: "11.222.333/0001-99",
      phone: "(21) 3000-3030",
      address: "Rua das Oficinas, 50\nGalpao 2\nRio de Janeiro - RJ",
      email: "frota@grupodelta.com.br",
      personType: "Pessoa Juridica",
      customerObservation: "Necessita contato previo para qualquer comando remoto.",
      vehicleContractObservation: "Contrato pausado temporariamente por ajuste comercial.",
    },
    vehicle: {
      id: 103,
      brand: "Toyota",
      model: "Hilux",
      plate: "XYZ9K87",
      year: "2020",
      color: "Preto",
      equipment: "MX-Tracker Lite",
      serial: "SN-12121212",
      carrier: "TIM",
      lineNumber: "(21) 96666-7788",
    },
    status: {
      hasBlocking: false,
      inMaintenance: false,
    },
    maintenance: {
      vehicleLabel: "XYZ9K87 - Hilux",
      startDate: "",
      endDate: "",
    },
    internalObservation: "Aguardar reativacao contratual para voltar monitoramento ativo.",
  },
};

const eventsByVehicleId = {
  101: [
    {
      id: 1,
      dateTime: "2026-04-15T08:20:00",
      statusOk: true,
      occurred: true,
      event: "Ignicao ligada",
      location: "Rua A, 100 - Sao Paulo/SP",
      speed: 32,
      latitude: -23.5505,
      longitude: -46.6333,
    },
    {
      id: 2,
      dateTime: "2026-04-15T09:15:00",
      statusOk: true,
      occurred: true,
      event: "Movimento",
      location: "Av. Brasil, 950 - Sao Paulo/SP",
      speed: 58,
      latitude: -23.556,
      longitude: -46.641,
    },
    {
      id: 3,
      dateTime: "2026-04-15T10:40:00",
      statusOk: false,
      occurred: false,
      event: "Sinal intermitente",
      location: "Marginal Tiete - Sao Paulo/SP",
      speed: 0,
      latitude: -23.52,
      longitude: -46.62,
    },
  ],
  102: [
    {
      id: 4,
      dateTime: "2026-04-14T14:00:00",
      statusOk: true,
      occurred: true,
      event: "Parada",
      location: "Av. do Contorno, 500 - BH/MG",
      speed: 0,
      latitude: -19.9191,
      longitude: -43.9386,
    },
  ],
  103: [],
};

function normalizeText(value) {
  return (value || "").toString().trim().toLowerCase();
}

function clone(data) {
  return JSON.parse(JSON.stringify(data));
}

async function getVehicles(filters = {}) {
  await wait(500);

  const plateFilter = normalizeText(filters.plate);
  const cpfCnpjFilter = normalizeText(filters.cpfCnpj);
  const clientNameFilter = normalizeText(filters.clientName);

  const data = mockVehicles.filter((vehicle) => {
    const byPlate =
      !plateFilter || normalizeText(vehicle.plate).includes(plateFilter);
    const byCpfCnpj =
      !cpfCnpjFilter || normalizeText(vehicle.cpfCnpj).includes(cpfCnpjFilter);
    const byClient =
      !clientNameFilter || normalizeText(vehicle.clientName).includes(clientNameFilter);

    return byPlate && byCpfCnpj && byClient;
  });

  return clone(data);
}

async function getVehicleDetails(vehicleId) {
  await wait(700);

  const details = detailsByVehicleId[vehicleId];
  if (!details) {
    throw new Error("Veiculo nao encontrado.");
  }

  return clone(details);
}

async function getEvents(vehicleId, filters = {}) {
  await wait(600);

  const events = eventsByVehicleId[vehicleId] || [];
  const { startDate, endDate, onlyOccurred } = filters;

  const filtered = events.filter((eventItem) => {
    const eventDate = new Date(eventItem.dateTime);
    const byStart = !startDate || eventDate >= new Date(`${startDate}T00:00:00`);
    const byEnd = !endDate || eventDate <= new Date(`${endDate}T23:59:59`);
    const byOccurred = !onlyOccurred || eventItem.occurred;

    return byStart && byEnd && byOccurred;
  });

  return clone(filtered);
}

async function saveObservation(vehicleId, observationText) {
  await wait(450);

  if (!detailsByVehicleId[vehicleId]) {
    throw new Error("Veiculo nao encontrado para salvar observacao.");
  }

  detailsByVehicleId[vehicleId].internalObservation = observationText ?? "";

  return {
    success: true,
    message: "Observacao salva com sucesso.",
  };
}

async function startMaintenance(vehicleId) {
  await wait(500);

  const details = detailsByVehicleId[vehicleId];
  if (!details) {
    throw new Error("Veiculo nao encontrado para manutencao.");
  }

  details.status.inMaintenance = true;
  details.maintenance.startDate = now.toISOString().slice(0, 10);
  details.maintenance.endDate = nextWeek.toISOString().slice(0, 10);

  return clone(details.maintenance);
}

export const vehicleService = {
  getVehicles,
  getVehicleDetails,
  getEvents,
  saveObservation,
  startMaintenance,
};
